export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11894.88840c15.jpg";